    export var scru = [
    {
        id: 99,
        img: require("../../Images/scrup1.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "350 EGP",
    },
    {
        id: 100,
        img: require("../../Images/scrup2.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "450 EGP",
    },
    {
        id: 101,
        img: require("../../Images/scrup3.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "250 EGP",
    },
    {
        id: 102,
        img: require("../../Images/scrup4.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "2500",
    },
    {
        id: 103,
        img: require("../../Images/scrup5.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1500",
    },
    {
        id: 104,
        img: require("../../Images/scrup6.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1300",
    },
    {
        id: 105,
        img: require("../../Images/scrup7.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "900",
    },
    {
        id: 106,
        img: require("../../Images/scrup8.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1200",
    },
    {
        id: 107,
        img: require("../../Images/scrup9.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1250",
    },
    {
        id: 108,
        img: require("../../Images/scrup10.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1400",
    },
    {
        id: 109,
        img: require("../../Images/scru11.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1350",
    },
    {
        id: 110,
        img: require("../../Images/scru12.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1550",
    },
    {
        id: 111,
        img: require("../../Images/scru13.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1550",
    },
    {
        id: 112,
        img: require("../../Images/scrup14.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1550",
    },
    {
        id: 113,
        img: require("../../Images/scrup15.webp"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1550",
    },
    {
        id: 114,
        img: require("../../Images/scrup16.jpg"),
        title: "scrup",
        description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price: "1550",
    },
    ];
